import { useTranslation } from "react-i18next";

/**
 * Attribution line for a single image: "Foto: <Titel>", linked when a URL
 * is on file. Renders nothing without a credit, so an image whose source
 * needs no naming stays uncluttered — which is the common case for our
 * own photos.
 *
 * `credit` is `{ title, url? }`. A URL without a title is treated as no
 * credit at all: there would be nothing to click, and "Foto: (Link)" is
 * not an attribution.
 */
export default function ImageCredit({ credit, style }) {
  const { t } = useTranslation();
  if (!credit?.title) return null;

  const baseStyle = { fontSize: "12px", lineHeight: 1.5, color: "rgba(254,250,239,0.55)", margin: 0, ...style };

  return (
    <p style={baseStyle}>
      {t("events.imageCreditPrefix")}
      {credit.url ? (
        // rel="noopener" because of target=_blank; the link points at
        // whoever we are crediting, which is usually off-site.
        <a href={credit.url} target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "underline" }}>
          {credit.title}
        </a>
      ) : (
        credit.title
      )}
    </p>
  );
}
